import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../services/api';
import './EmailVerification.css';
import { helpers } from '../services/helpers';
import ColorOptions from './ColorOptions'
import { faker } from '@faker-js/faker';

function EmailVerification({ saveUser, toast }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [error, setError] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [selectedColor, setSelectedColor] = useState('#e0e0e0'); // Default light gray color
  const [initialLoad, setInitialLoad] = useState(true);
  const [saving, setSaving] = useState(false)
  const colors = [...helpers.colors];

  const generateRandomUsername = () => {
    return `${faker.word.adjective()}_${faker.word.noun()}${faker.number.int({ max: 999 })}`
      .toLowerCase()
      .replace(/\s+/g, '');
  };
  useEffect(() => {
    if (initialLoad) {
      setUsername(generateRandomUsername());
      const randomColor = colors[Math.floor(Math.random() * colors.length)].value;
      setSelectedColor(randomColor);
      setInitialLoad(false);
    }
  }, [initialLoad]);
  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setStatus('error');
        setError('No verification token provided');
        return;
      }

      try {
        const isValid = await api.isCodeValid(token);
        if (isValid.isValid) {
          setStatus('create-password');
        } else {
          setStatus('error');
          setError('Invalid or expired verification token');
        }
      } catch (err) {
        setStatus('error');
        setError(err.message || 'Failed to verify email');
      }
    };

    verifyEmail();
  }, [searchParams]);

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPasswordError('');

    if (password.length < 8) {
      setPasswordError('Password must be at least 8 characters long');
      return;
    }

    if (password !== confirmPassword) {
      setPasswordError('Passwords do not match');
      return;
    }
    setSaving(true)

    try {
      const token = searchParams.get('token');
      const data = await api.createPassword(token, password, username, selectedColor);
      saveUser(data);
      toast('Account created successfully!');
      navigate('/surgeries');
    } catch (err) {
      if (err?.response?.data?.error == "Username is already taken") {
        setUsernameError('Username is already taken')
      } else {
        setPasswordError(err.message || 'Failed to create account');
      }
    }
  };

  return (
    <div className="email-verification scrollable" id="email-verification">
      <div className="verification-content">
        {status === 'verifying' && (
          <>
            <h2>Verifying Your Email</h2>
            <p>Please wait while we verify your email address...</p>
            <div className="loading-spinner"></div>
          </>
        )}

        {status === 'create-password' && (
          <>
            <h2>Create Your Account</h2>

            <ColorOptions
              colors={colors}
              selectedColor={selectedColor}
              setSelectedColor={setSelectedColor}
            />
            <form onSubmit={handlePasswordSubmit} className="password-form">
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => {
                    setUsername(e.target.value)
                    setUsernameError('')
                  }}
                  required
                  minLength="3"
                  className={usernameError ? 'error' : ''}
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setPasswordError('');
                  }}
                  required
                  minLength="8"
                  className={passwordError ? 'error' : ''}
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={
                    (e) => {
                      setConfirmPassword(e.target.value)
                      setPasswordError('');
                    }
                  }
                  required
                  minLength="8"
                  className={passwordError ? 'error' : ''}
                />
              </div>
              {(passwordError || usernameError) && <div className="error-message">{passwordError || usernameError}</div>}
              <button type="submit" className="continue-button" disabled={!username || !password || !confirmPassword || saving}>
                Create Account
              </button>
            </form>
          </>
        )}

        {status === 'success' && (
          <>
            <h2>Account Created!</h2>
            <p>Your account has been successfully created. You will be redirected to the login page shortly.</p>
            <div className="success-icon">✓</div>
          </>
        )}

        {status === 'error' && (
          <>
            <h2>Verification Failed</h2>
            <p className="error-message">{error}</p>
            <button
              className="retry-button"
              onClick={() => navigate('/surgeries')}
            >
              Return to Home
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default EmailVerification; 